module.exports = __webpack_public_path__ + "media/oyasuminasai.eaef7dbc.mp3";